// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-p_gn","galleryThumbnail_active":"c-p_go","galleryThumbnail__image":"c-p_gp"};